import { Location, PlatformLocation } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { EventTrackerService, HttpService } from '@app/core';
import { IndicatorService } from '@app/shared';
import { SubscriptionLike } from 'rxjs';
import { map } from 'rxjs/operators';

import { commentRating } from '../pdp-model';
import { ProductComment } from './../pdp-model';
import {PlayerService} from "@app/components/player/player.service";
import {NavigationBarService} from "@app/shared/navigation-bar/navigation-bar.service";

export interface rateDic { [key: number]: number }

@Component({
  selector: 'navaar-pdp-comment',
  templateUrl: './pdp-comment.component.html',
  styleUrls: ['./pdp-comment.component.scss']
})
export class PdpCommentComponent implements OnInit, OnDestroy {
  public rate: commentRating;
  public isShowRate: boolean = false;
  public ratoToComment: number = 0;
  public rateDic: rateDic = {};
  public comment: Array<ProductComment> = [];
  public totalCountComment: number;
  public isEnd: boolean = false;

  public pageNumber: number = 0;
  public pageSize: number = 6;
  public isLoading: boolean;
  public audiobookId: string;
  public audiobookTitle: string;
  public id: number;
  private _location: SubscriptionLike;


  constructor(
    public readonly playerService: PlayerService,
    public readonly navigationBarService: NavigationBarService,
    private readonly platformLocation: PlatformLocation,
    private readonly location: Location,
    private readonly eventTracker: EventTrackerService,
    private readonly indicator: IndicatorService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly http: HttpService) { }

  public ngOnInit() {
    this._location = this.location.subscribe(c => {
      this.isShowRate = false;
    });
    this.activatedRoute.paramMap.subscribe(c => {
      this.id = +this.activatedRoute.snapshot.paramMap.get('id');
      this.audiobookTitle = this.activatedRoute.snapshot.queryParamMap.get('title');
      this.audiobookId = this.activatedRoute.snapshot.paramMap.get('audiobookId');
      this.getComment(this.id).then();
      this.getRate(this.audiobookId).then();
    });
  }

  public async goToNextPage(page: number) {
    this.isLoading = true;
    this.pageNumber = page;
    await this.getComment(this.id);
  }
  private async getComment(id) {
   await this.http.post(`/api/ratereview/Get/${id}?$skip=${this.pageNumber * this.pageSize}&$top=${this.pageSize}&$inlinecount=allpages`).pipe(
      map(c => {
        this.totalCountComment = c.count;
        if(this.totalCountComment == 0){
          this.showPopupRateToComment();
          return;
        }
        this.comment = this.comment.concat(c.items);
        this.isEnd = (this.comment.length === c.count);
        this.indicator.hideHude();
        this.isLoading = false;
      })
    ).toPromise();
  }

  public logItem(name: string, obj: object) {
    let _obj = {
      ...{
        item_id: this.id,
        'audiobook-title': this.audiobookTitle
      }, ...obj
    };
    this.eventTracker.logEvent(name, _obj);
  }

  private async getRate(audiobookId) {
    await this.http.get(`/api/ratereview/rating/${audiobookId}`).pipe(
      map(c => {
        this.rate = c;
        for (const iterator of this.rate.ratingDetails)
          this.rateDic[iterator.key] = iterator.value;
        this.indicator.hide();
      })
    ).toPromise();
  }

  public showPopupRateToComment() {
    this.ratoToComment = 0;
    this.isShowRate = true;
    this.addModalOpenedToUrl();
    this.logItem('x_btn_rate_to_audiobook_comment_submit', {});
  }

  public onSubmitPopupRateToComment(e) {
    this.ratoToComment = e['index'];
    this.logItem('x_btn_rate_to_audiobook_comment_submit', {
      audiobookId: this.audiobookId,
      rate: e['index']
    });
    this.onBackKeyButton(() => this.isShowRate = false);
  }

  private addModalOpenedToUrl() {
    // this.router.navigate([], {fragment: 'modalOpened'}).then();
    this.platformLocation.pushState(null, null, location.href + '#modalOpened');
  }

  private onBackKeyButton(callback?: () => {}) {
    if (this.location.path(true).includes('#modalOpened')) {
      this.location.back();
    }
    if (callback)
      callback();
  }

  public calculateBarWidth(rate): number {
    return (rate / this.rate.ratingsQuantity) * 100;
  }

  ngOnDestroy(): void {
    if (this._location)
      this._location.unsubscribe();
  }
}
